import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  // Scroll to top after navigation
  const handleFooterLinkClick = () => {
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 0);
  };
const version = process.env.REACT_APP_VERSION 
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-logo-col">
          <p>Empowering your learning journey with the best online courses and resources to help you achieve your goals.</p>
        </div>
        <div className="footer-links-col">
          <div className="footer-section-title">Learn</div>
          <Link to="/my-courses" onClick={handleFooterLinkClick}>My Courses</Link>
          <Link to="/departments" onClick={handleFooterLinkClick}>Departments</Link>
          {/* <a href="#wishlist">Wishlist</a>
          <a href="#archive">Archive</a> */}
        </div>
        <div className="footer-links-col">
          <div className="footer-section-title">Support</div>
         
          <Link to="/help-center" onClick={handleFooterLinkClick}>Help Center</Link>
          <Link to="/feedback" onClick={handleFooterLinkClick}>Feedback</Link>
        </div>
        <div className="footer-links-col">
          <div className="footer-section-title">Account</div>
          <Link to="/certificates" onClick={handleFooterLinkClick}>Certificates</Link>
          <Link to="/profile" onClick={handleFooterLinkClick}>Profile</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} CriticalRiver. All rights reserved. Version {version}</p>
        <div className="footer-social">
          <a href="https://www.facebook.com/criticalriver/" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fa fa-facebook"></i>
          </a>
          <a href="https://in.linkedin.com/company/criticalriver" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="fa fa-linkedin"></i>
          </a>
          <a href="https://x.com/CriticalRiver?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <i className="fa fa-twitter"></i>
          </a>
          <a href="https://www.instagram.com/criticalriver/?hl=en" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="fa fa-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;